var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.363,
    height: 35.364,
    viewBox: "0 0 35.363 35.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(9.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rahmen",
    d: "M26.132,35.364H9.231A9.242,9.242,0,0,1,0,26.132V9.231A9.242,9.242,0,0,1,9.231,0h16.9a9.242,9.242,0,0,1,9.231,9.231v16.9a9.242,9.242,0,0,1-9.231,9.231M9.231,3.025A6.214,6.214,0,0,0,3.024,9.231v16.9a6.214,6.214,0,0,0,6.207,6.207h16.9a6.214,6.214,0,0,0,6.207-6.207V9.231a6.214,6.214,0,0,0-6.207-6.207Z",
    transform: "translate(-9.935)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_66",
    "data-name": "Pfad 66",
    d: "M52.764,51.1c0-1.1,0-2.435-.025-3.4h3.072a12.79,12.79,0,0,1,.122,1.532c.46-.9,1.451-1.841,3.777-1.841,2.536,0,3.362,1.832,3.362,5.124v5.8H59.9V52.88c0-1.6-.639-2.722-1.669-2.722-1.786,0-2.3,1.14-2.3,3.507v4.65H52.764Z",
    transform: "translate(-47.176 -33.115)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_67",
    "data-name": "Pfad 67",
    d: "M3.693,1.847A1.847,1.847,0,1,1,1.847,0,1.847,1.847,0,0,1,3.693,1.847",
    transform: "translate(0.061 9.333)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24",
    "data-name": "Rechteck 24",
    width: 3.169,
    height: 10.459,
    transform: "translate(0.322 14.742)",
    fill: "#73c9e2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.89b9a77bd81c88f7b9ec4f09b3dd6566.svg";
export { ForwardRef as ReactComponent };